import React from 'react';

import RichTextEditorStyle from './richTextEditor';

// Global Ant Design component style overrides shared across apps.
const Overrides = () => <RichTextEditorStyle />;

export default Overrides;
